import { Skeleton } from '@picsart/design-system/components/Skeleton';
import useStyles from './styles';

const FallBack = () => {
  const classes = useStyles();

  return (
    <div className={classes.root} data-testId="fallback">
      {Array.from({ length: 8 }, (_, i) => (
        <Skeleton key={`s${i}`} className={classes.skeleton} width={178} height={256} />
      ))}
    </div>
  );
};

export default FallBack;
